import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../config/firebase-config';
import { notifyPermissionDenied } from '../handleCallableError';

export const getAllAuctionsByDealership = async (
  dealershipOrParams,
  startDate = null,
  endDate = null,
) => {
  if (dealershipOrParams === null) {
    return;
  }

  try {
    const getAllAuctionsFn = httpsCallable(functions, 'getAllAuctionsByDealershipIdV2');
    const params =
      typeof dealershipOrParams === 'object'
        ? { ...dealershipOrParams }
        : { dealership: dealershipOrParams };
    delete params.throwOnError;
    params.requestedApp ||= 'dealership_web';
    if (params.startDate instanceof Date) params.startDate = params.startDate.getTime();
    if (params.endDate instanceof Date) params.endDate = params.endDate.getTime();
    if (params.startDate === undefined) {
      params.startDate = startDate instanceof Date ? startDate.getTime() : null;
    }
    if (params.endDate === undefined) {
      params.endDate = endDate instanceof Date ? endDate.getTime() : null;
    }
    const result = await getAllAuctionsFn(params);
    if (result.data.success === 'yes') {
      return {
        success: 'yes',
        hasMore: result.data.hasMore === true,
        nextCursor: result.data.nextCursor || null,
        docs: result.data.data.map((auction) => ({
          id: auction.id,
          data: () => auction,
        })),
      };
    } else {
      return { success: 'no', message: result.data.message };
    }
  } catch (error) {
    console.error('Error obteniendo subastas por dealership:', error);
    notifyPermissionDenied(error);
    if (typeof dealershipOrParams === 'object' && dealershipOrParams.throwOnError) throw error;
    return { success: 'no', message: error.message };
  }
};
